/* eslint-disable */
import {Service} from 'components/Shared/server';
import {EditorialPaginationResponse} from 'models/EditorialPaginationResponse';


export const routeGetEditorials = (page: number, group: string, articleFilter: string) => `/api/editorials/editorials?page=${page}&group=${encodeURIComponent(group)}&articleFilter=${encodeURIComponent(articleFilter)}`;
export function getEditorials(page: number, group: string, articleFilter: string): Promise<EditorialPaginationResponse> {
  return Service.get<EditorialPaginationResponse>({
    url: routeGetEditorials(page, group, articleFilter)
  });
}
